<div (click)="turnToPage()"
     (keydown.enter)="turnToPage()"
     (keydown.space)="$event.preventDefault(); turnToPage()"
     (mouseout)="mouseOut()"
     (mouseover)="mouseOver()"
     class="search-item"
     tabindex="0"
     role="button"
>
  <span class="logo">
    {{ hierarchy.join('.') }}@if (hierarchy && hierarchy.length > 0) {
      <span>.</span>
  }
</span>
    <span class="element-wrapper">

  <span class="description">
    {{ getPreText() | stripHtml }}<span
          class="result">{{ getResultText() | stripHtml }}</span>{{ getPostText() | stripHtml }}
  </span>

        @if (getRealPageNumber() > 0) {
            <span class="page-number"><a>{{ getRealPageNumber() }}</a></span>
        }
        @if (getRealPageNumber() < 0) {
            <span class="page-number"><button (click)="turnToPage()">-</button></span>
        }

</span>
</div>